const NO_IMPORT = 'No import'
const UPLOADING = 'Uploading...'
const CONVERTING = 'Converting...'
const ERROR_REACH_LIMIT = '<div>Maximum file size is 50 MB. Maximum slide amount is 100 slides. <br /> Please try again with a smaller file.</div>'
const ERROR_UNSUPPORTED_FILE_TYPE = 'Could not upload this file (only support file pptx, ppt, pdf).'
const IMPORT_PPT_UPLOADING = 2
const IMPORT_PPT_CONVERTING = 3

export default {
  NO_IMPORT,
  UPLOADING,
  CONVERTING,
  ERROR_REACH_LIMIT,
  ERROR_UNSUPPORTED_FILE_TYPE,
  IMPORT_PPT_UPLOADING,
  IMPORT_PPT_CONVERTING,
}
